import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import * as valid from 'utils/validate';
import { renderKBInput, renderKBMorePhotoUpload, renderKBTextarea } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import {
KBPopover,
KBButton } from
'components';

var OfflineRefundForm = class extends React.Component {constructor(props) {super(props);this.refundOrder = this.refundOrder.bind(this);}refundOrder(

  model) {
    const { callBack } = this.props;
    callBack && callBack({
      ...model,
      nwf_attachments: [model.pdfFile],
      pdfFile: undefined,
      refund: true });

    KBPopover.close();
  }render()

  {
    const {
      submitting,
      handleSubmit } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.refundOrder)}>
        <div className="kb-form-header">
          <h2 className="header-title">线下退款</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </div>
        <div className="kb-form-container">
          <div className="kb-row" style={{ textAlign: 'left' }}>
            <Field
            name="pdfFile"
            component={renderKBMorePhotoUpload}
            uploadedText="点击上传"
            photoShow={false}
            sort={false}
            className="kb-form-group kb-form-alone"
            text="点击上传"
            accept=".pdf"
            title="上传审批单（PDF文件）"
            isRequired={true} />

          </div>
          <div className="kb-row kb-form-66">
            <Field
            name="nwf_number"
            component={renderKBInput}
            className="kb-form-group kb-div-c39"
            isRequired={true}
            title="运营单号" />

          </div>
          <div className="kb-row">
            <Field
            name="note"
            component={renderKBTextarea}
            className="kb-form-group kb-form-c18 kb-form-alone"
            isRequired={true}
            title="备注" />

          </div>
          <div className="kb-row">
            <div className="kb-form-fr">
              <span
              className="cancel-btn"
              onClick={KBPopover.close}
              style={{ marginRight: '20px' }}>

                取消
              </span>
              <KBButton
              className="certain-btn kb-from-cmr"
              type="submit"
              submitting={submitting}>

                确定
              </KBButton>
            </div>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  return {
    // initialValues:
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};
  if (valid.required(values.pdfFile)) {
    errors.pdfFile = '请上传审批单';
  }

  if (valid.required(values.nwf_number)) {
    errors.nwf_number = '请输入运营单号';
  }

  if (valid.required(values.note)) {
    errors.note = '请输入备注';
  }
  return errors;
};

const formConfig = {
  form: 'MemberLocationRolesForm',
  touchOnBlur: false,
  validate: validate };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(OfflineRefundForm));
